// extracted by mini-css-extract-plugin
module.exports = {"Root":"profile_Root__1rY_x","Paper":"profile_Paper__177yt","Button":"profile_Button__3nm2I","Link":"profile_Link__35p66","Item":"profile_Item__3v3GU"};